import robPortrait from "@/assets/rob-portrait-transparent.png";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { trackCta } from "@/lib/trackCta";

export const Story = () => {
  return (
    <section className="py-24 bg-background relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-background via-muted/10 to-background" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid md:grid-cols-[45%_55%] gap-16 items-start max-w-7xl mx-auto">
          <div className="order-2 md:order-1 animate-fade-in flex items-start justify-center md:pt-8">
            <div className="relative w-full max-w-lg">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary/10 via-accent/5 to-primary/10 rounded-2xl blur-xl" />
              <div className="relative">
                <img 
                  src={robPortrait} 
                  alt="Rob Lasa" 
                  width="662"
                  height="1077"
                  loading="eager"
                  fetchPriority="high"
                  className="w-full h-auto rounded-lg shadow-2xl border border-border/20"
                />
              </div>
            </div>
          </div>

          <div className="order-1 md:order-2 space-y-6 animate-slide-up md:pl-4">
            <h2 className="font-display text-4xl md:text-5xl font-bold text-foreground leading-tight">
              I'm Rob. Dad of four boys.
              <span className="block mt-2 text-accent">I'm still figuring this out.</span>
            </h2>

            <div className="space-y-4 text-lg text-muted-foreground leading-relaxed">
              <p>
                Not a therapist. Not a coach. Not a preacher. Just a guy who spent years 
                performing niceness until it almost killed him — and finally stopped.
              </p>
              
              <p>
                I was there at every dinner, every bedtime, every moment. But I wasn't present. 
                I was performing. And I didn't even know it.
              </p>
              
              <p className="font-semibold text-foreground border-l-4 border-accent pl-4 py-2">
                My kids had a provider. They didn't have me.
              </p>
              
              <p>
                This space exists because I needed it and couldn't find it. 
                No formulas. No five-step plans. Just honest conversation about what it actually 
                takes to stop performing and start being present.
              </p>
            </div>
            
            <div className="pt-6">
              <Button asChild size="lg" className="shadow-elegant font-bold">
                <Link to="/about" onClick={() => trackCta("home_story_about", "/about", "More About Me")}>More About Me</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
